// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InfosBox from "@store/Library/Components/Toolkit/InfosBox";
import React from "react";
import { FC } from "react";

type CartMessagesProps = WidgetProps;

const CartMessages: FC<CartMessagesProps> = () => {
    const cart = useAppSelector(state => getCurrentCartState(state).value);

    return cart?.messages && cart?.messages?.length > 0 ? (
        <InfosBox type="warning" size="small">
            {cart?.messages}
        </InfosBox>
    ) : null;
};

const widgetModule: WidgetModule = {
    component: CartMessages,
    definition: {
        group: "Cart",
        allowedContexts: ["CartPage", "CheckoutReviewAndSubmitPage", "OrderConfirmationPage"],
    },
};

export default widgetModule;
